import React from "react";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown
} from "reactstrap";
import { IconToTheSide } from "../../components/buttons/FormControlButton";
import emailAlertsFiltersStore from "./EmailAlertsFiltersStore";

const filterOptions = [
  { id: "all", label: "All" },
  { id: "createdByMe", label: "Created By Me" },
  { id: "addressedToMe", label: "Addressed To Me" }
];

export default function EmailAlertsUserFilter(props) {
  const activeItem = filterOptions.filter(
    (x) => x.id === emailAlertsFiltersStore.state.userFilterModelValue
  )[0];
  return (
    <UncontrolledDropdown>
      <DropdownToggle
        tag="div"
        className={"form-control dropdown-toggle dropdown-toggle-no-icon"}
      >
        {activeItem.label}
        <IconToTheSide
          side="right"
          icon={<span className="far fa-chevron-down" />}
        />
      </DropdownToggle>
      <DropdownMenu>
        {filterOptions.map((x, index) => (
          <DropdownItem
            key={index}
            onClick={() =>
              emailAlertsFiltersStore.setState({
                userFilterModelValue: x.id
              })
            }
            active={activeItem.id === x.id}
          >
            {x.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
